export function ExpandIcon() {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <path
        d="M3 7V3h4v1.5H4.5V7H3Zm10-4h4v4h-1.5V4.5H13V3ZM3 13h1.5v2.5H7V17H3v-4Zm12.5 0H17v4h-4v-1.5h2.5V13Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <path
        d="m5.72 4.66 4.28 4.28 4.28-4.28 1.06 1.06-4.28 4.28 4.28 4.28-1.06 1.06-4.28-4.28-4.28 4.28-1.06-1.06 4.28-4.28-4.28-4.28 1.06-1.06Z"
        fill="currentColor"
      />
    </svg>
  );
}
